<template>
    <div class="loading" :data-fullscreen="full ? true : null" >
        <span> {{ $t('LABEL.LOADING')}} </span>
    </div>
</template>

<script>
    export default {
        name: "loading",
        props: ['full']
    }
</script>



// WEBPACK FOOTER //
// src/components/common/loading.vue